import { get } from '@/api/request'
import { PaginationResponse, PaginationParams } from '@/api/base'

// 品牌信息
export interface Brand {
  id: number
  name: string
  logo: string
  desc?: string
  createdTime: string
  website?: string
  productCount?: number
  verificationCount?: number
  joinTime?: string
  establishTime?: string
}

// 品牌产品
export interface BrandProduct {
  id: string
  name: string
  image: string
  category: string
  releaseDate: string
  verificationCount: number
}

/**
 * 获取品牌列表
 */
export const queryBrandList = (params: PaginationParams = { page: 1, size: 10 }) => {
  return get<PaginationResponse<Brand>>(' /authenti-guard/v1/api/brand/list', params)
}

/**
 * 获取品牌详情
 */
export const queryBrandDetail = (brandId: number) => {
  return get<Brand>(`/authenti-guard/v1/api/brand/${brandId}`)
}

/**
 * 获取品牌产品列表
 */
export const queryBrandProducts = (brandId: number, params: PaginationParams = { page: 1, size: 10 }) => {
  return get<PaginationResponse<BrandProduct>>(`/authenti-guard/v1/api/brands/${brandId}/products`, params)
}
